// Proud Little Readers: ebook upsell buttons inside the Horizon cart drawer.
// The upsell markup comes from snippets/plr-upsell-box.liquid (rendered in snippets/cart-drawer.liquid).
import { sectionRenderer } from '@theme/section-renderer';

if (!window.__pluDrawer) {
  window.__pluDrawer = true;

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('#cart-drawer .plu-add') : null;
    if (!button) return;
    event.preventDefault();

    const ids = (button.dataset.ids || '').split(',').filter(Boolean);
    button.closest('.plu')?.querySelectorAll('.plu-add').forEach((b) => { b.disabled = true; });
    button.textContent = 'Adding…';

    try {
      const items = ids.map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('add failed');

      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
      });

      await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration' });

      // If the drawer did not refresh (the clicked buttons are still there and disabled), fall back to a reload.
      if (document.querySelector('#cart-drawer .plu-add[disabled]')) location.reload();
    } catch (err) {
      location.reload();
    }
  });
}
